import { useMediaQuery } from "@hortis/ui/hooks/media-query";
import type { PropsWithChildren, ReactElement } from "react";
import { CreateAccessionDialog } from "src/features/create-accession/components/create-accession-dialog";
import { useToggle } from "src/utils/hooks/toggle";
import { CreateMaterialDialog } from "../dialog/variants/create-material-dialog";
import { MobileTopBar } from "./mobile-topbar";
import { NavDrawer } from "./nav-drawer/nav-drawer";
import { useNavSites } from "./site-context/use-nav-sites";
import { useTopbarStore } from "./topbar/topbar-store";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface NavLayoutProps {}

export const NavLayout = ({
  children,
}: PropsWithChildren<NavLayoutProps>): ReactElement => {
  const [open, toggleOpen] = useToggle();
  const mobileTopBarTitle = useTopbarStore((state) => state.title);
  const isDesktop = useMediaQuery("lg");
  const { activeSite } = useNavSites();

  return (
    <div
      className="flex h-full flex-col lg:flex-row"
      style={{ minHeight: "calc(var(--vh, 1vh) * 100)" }}
    >
      {activeSite != null && (
        <>
          <CreateAccessionDialog siteSlug={activeSite.urlSlug} />
          <CreateMaterialDialog siteSlug={activeSite.urlSlug} />
        </>
      )}
      {!isDesktop && (
        <div className="top-0">
          <MobileTopBar onMenuClick={toggleOpen} drawerOpen={open}>
            {mobileTopBarTitle}
          </MobileTopBar>
        </div>
      )}
      <NavDrawer open={open} toggleOpen={toggleOpen} isPermanent={isDesktop} />
      <div className="flex h-full flex-1 overflow-hidden bg-grey-25 lg:p-1 lg:pl-0">
        <main
          className="flex h-full flex-1 flex-col overflow-hidden border-grey-200 bg-white lg:rounded-xl lg:border lg:shadow-xs"
          id="scrollable-page-content"
        >
          {children}
        </main>
      </div>
    </div>
  );
};
